import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { GetDecodedToken } from 'libs/core/src/lib/utils/token-decode';
import { RepresentativeService } from 'libs/core/src/lib/services/representative.service';
import { SystemUserRole } from '@inshuwa-client/models';
import { lastValueFrom, map } from 'rxjs';

export const loginGuard = async () => {
  const nzModalService = inject(NzModalService);
  const representativeService = inject(RepresentativeService);
  const decoded = GetDecodedToken();

  if (!decoded) {
    inject(Router).navigate(['/'], { replaceUrl: true });
    return false;
  }

  const { role, id } = decoded;

  if (
    role.toLowerCase() !== SystemUserRole.BrokerRepresentative.toLowerCase()
  ) {
    nzModalService.error({
      nzContent: 'You are not authorized to access this portal',
    });

    return false;
  }

  const repStatus = await lastValueFrom(
    representativeService
      .getRepresentativeBrokerById(Number(id))
      .pipe(
        map((value) => {
          localStorage.setItem(
            SystemUserRole.BrokerRepresentative,
            JSON.stringify(value),
          );
          return true;
        }),
      ),
  );

  if (!repStatus) {
    nzModalService.error({
      nzContent: 'You are not authorized to access this portal',
    });
    return false;
  }

  return repStatus;
};
